//* Libraries imports
import { BaseApiService } from "@services/baseApiService";
import { ApiResponse, ApiError } from "@/types/api";
import { api } from "@services/api";

//* Types imports
import type {
  TechinicalOutputDTO,
  TechinicalDocumentResponse,
  MappingRule,
  TechinicalPieceConfig,
} from "./types";
class TechinicalService extends BaseApiService<TechinicalOutputDTO> {
  constructor() {
    super("techinicals-documents");
  }

  async create(
    data: Partial<TechinicalOutputDTO>
  ): Promise<ApiResponse<TechinicalOutputDTO> | ApiError> {
    // Remove sensitive data if needed
    const techinicalData = {
      ...data,
    };

    return await super.create(techinicalData);
  }

  async update(
    id: string,
    data: Partial<TechinicalOutputDTO>
  ): Promise<ApiResponse<TechinicalOutputDTO> | ApiError> {
    // Remove sensitive data if needed
    const techinicalData = {
      ...data,
    };

    return await super.update(id, techinicalData);
  }

  async generateDocument(
    id: string,
    payload: {
      mappingRules?: MappingRule[];
      clientId?: string;
      filledFormId?: string;
      replacements?: Record<string, string>;
    }
  ): Promise<ApiResponse<TechinicalDocumentResponse> | ApiError> {
    return await api.request<TechinicalDocumentResponse>(
      `${this.baseUrl}/${id}/document`,
      {
        method: "POST",
        body: JSON.stringify(payload),
      }
    );
  }

  async getConfig(
    id: string
  ): Promise<ApiResponse<{ config: TechinicalPieceConfig }> | ApiError> {
    return await api.request<{ config: TechinicalPieceConfig }>(
      `${this.baseUrl}/${id}/config`,
      {
        method: "GET",
      }
    );
  }

  async saveConfig(
    id: string,
    payload: {
      mappings: MappingRule[];
      baseForm?: string;
    }
  ): Promise<ApiResponse<{ config: TechinicalPieceConfig }> | ApiError> {
    return await api.request<{ config: TechinicalPieceConfig }>(
      `${this.baseUrl}/${id}/config`,
      {
        method: "POST",
        body: JSON.stringify(payload),
      }
    );
  }
}

export const techinicalService = new TechinicalService();
